import React, { Component } from 'react'
import MaterialIcon from "material-icons-react";
import DropZone from 'react-dropzone';
import HttpClient from "../../utils/HttpClient/HttpClient";
import Auth from "../../auth/Auth";
import { Col, Row } from "react-bootstrap";
import { Button, Well, ControlLabel } from "react-bootstrap";
import { onUserPictureChange, changePassword } from "../../reducers/application/applicationActions";
import { connect } from "react-redux";
import { NO_PIC_PROFILE } from "../../constants/profileConstant";
import { SCREEN_THRESHOLD } from "../../global/constants";
import classNames from 'classnames';

class ProfileView extends Component {

    httpClient;
    auth;
    isDesktop;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        let user = this.auth.getUser();
        this.state = {
            waitForDrop: false,
            picProfile: user.photoUrl,
            currentPassword: "",
            newPassword: "",
            repeatNewPassword: "",
            currentPasswordError: null,
            newPasswordError: null,
            repeatNewPasswordError: null
        };
        this.httpClient = new HttpClient(true);
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD;
    }

    onPictureDropped(accepted, rejected) {
        accepted.map((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result;
                const config = { headers: { 'Content-Type': 'text/plain' } };
                this.httpClient.post("oga/profile/upload", base64, config);
                this.setState({ picProfile: base64, waitForDrop: false });
                this.auth.setUserPicture(base64);
                this.props.onUserPictureChange(base64)
            };
            reader.readAsDataURL(file);
        });
        rejected.map((f) => alert("Solo png o jpeg"));
    }

    startDrop() {
        this.setState({ waitForDrop: !this.state.waitForDrop });
    }

    handleCurrentPasswordChange(event) {
        this.setState({
            currentPassword: event.target.value
        });
        this.validateFieldRequired("currentPasswordError", event.target.value);
    }

    handleNewPasswordChange(event) {
        this.setState({
            newPassword: event.target.value
        });
        if (!this.validateFieldRequired("newPasswordError", event.target.value)) return;
        this.validatePasswordMatch(event.target.value, this.state.repeatNewPassword);
    }

    handleRepeatNewPasswordChange(event) {
        this.setState({
            repeatNewPassword: event.target.value
        });
        if (!this.validateFieldRequired("repeatNewPasswordError", event.target.value)) return;
        this.validatePasswordMatch(this.state.newPassword, event.target.value);
    }

    validateFieldRequired(fieldError, value) {
        if (value.length < 6) {
            this.setState({
                [fieldError]: (
                    <small className="text-danger">
                        Su contraseña debe tener al menos 6 caracteres
              </small>
                )
            })
            return false;
        } else {
            this.setState({ [fieldError]: null });
            return true;
        }
    }

    validatePasswordMatch(newPasswordValue, repeatNewPasswordValue) {
        if (newPasswordValue !== repeatNewPasswordValue) {
            let matchError = (<small className="text-danger">
                Las contraseñas no coinciden
        </small>);
            this.setState({
                repeatNewPasswordError: matchError,
                newPasswordError: matchError
            })
            return false;
        } else {
            this.setState({ repeatNewPasswordError: null, newPasswordError: null });
            return true
        }
    }

    handleChangePassword() {
        if (!this.validateFieldRequired("currentPasswordError", this.state.currentPassword)) return;
        if (!this.validateFieldRequired("newPasswordError", this.state.newPassword)) return;
        if (!this.validateFieldRequired("repeatNewPasswordError", this.state.repeatNewPassword)) return;
        if (!this.validatePasswordMatch(this.state.newPassword, this.state.repeatNewPassword)) return;
        let data = {
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword
        }
        this.props.changePassword(data);
    }

    render() {
        let waitForDrop = this.state.waitForDrop;
        let btnText = waitForDrop ? "Drop" : "Cambiar foto";
        let wrapperClass = !this.isDesktop ? "block" : "block";
        let picClass = !this.isDesktop ? "w-100" : "w-200px";

        const currentPasswordClass = classNames('form-group',
            { 'has-error': this.state.currentPasswordError != null }
        );
        const newPasswordClass = classNames('form-group',
            { 'has-error': this.state.newPasswordError != null }
        );
        const repeatNewPasswordClass = classNames('form-group',
            { 'has-error': this.state.repeatNewPasswordError != null }
        );
        return (
            <div className="fade-show">
                <Row>
                    <Col md={12}>
                        <h1 className="header">Perfil</h1>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <div className={wrapperClass}>
                            <div className={picClass} style={{ marginBottom: "20px" }}>
                                <div className="centered">
                                    {
                                        !waitForDrop ?
                                            <img style={{ width: "150px", height: "150px", margin: "20px" }}
                                                className="rounded-circle cursor"
                                                src={this.state.picProfile}
                                                onError={(e) => { e.target.src = NO_PIC_PROFILE }} />
                                            :
                                            <DropZone
                                                className={"show"}
                                                accept="image/jpeg, image/png"
                                                onDrop={(accepted, rejected) => this.onPictureDropped(accepted, rejected)}>
                                                <div className='drop-zone'>
                                                    <div style={{ width: "150px", height: "150px", margin: "20px" }}
                                                        className="rounded-circle cursor bg-primary centered" >
                                                        <MaterialIcon icon="cloud_upload" size="44px" color="white" />
                                                    </div>
                                                </div>
                                            </DropZone>
                                    }
                                </div>
                                <div className="w-100">
                                    <div className="centered">
                                        <Button className="btn-primary"
                                            onClick={() => this.startDrop()}>{btnText}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Well bsSize="large" bsClass="wallet_transfer__card">
                            <div className="profile__change_password_cont">
                                <div className="wallet-transfer__balance">
                                    <b>Cambiar contraseña</b>
                                </div>
                            </div>

                            <div className={currentPasswordClass}>
                                <ControlLabel><b>Contraseña actual:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="password" className="form-control"
                                        onChange={(evt) => this.handleCurrentPasswordChange(evt)}
                                        name="invoiceName"
                                        value={this.state.currentPassword}
                                        placeholder="Contraseña Actual" />
                                </div>
                                <span className="help-block">{this.state.currentPasswordError}</span>
                            </div>

                            <div className={newPasswordClass}>
                                <ControlLabel><b>Nueva contraseña:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="password" className="form-control"
                                        onChange={(evt) => this.handleNewPasswordChange(evt)}
                                        name="invoiceName"
                                        value={this.state.newPassword}
                                        placeholder="Nueva contraseña" />
                                </div>
                                <span className="help-block">{this.state.newPasswordError}</span>
                            </div>

                            <div className={repeatNewPasswordClass}>
                                <ControlLabel><b>Repetir contraseña nueva:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="password" className="form-control"
                                        onChange={(evt) => this.handleRepeatNewPasswordChange(evt)}
                                        name="invoiceName"
                                        value={this.state.repeatNewPassword}
                                        placeholder="Repetir contraseña Actual" />
                                </div>
                                <span className="help-block">{this.state.repeatNewPasswordError}</span>
                            </div>

                            <Button className="btn-primary"
                                onClick={() => this.handleChangePassword()}>Cambio de Contraseña</Button>
                        </Well>
                    </Col>
                </Row>

            </div>
        )
    }
}
export default connect(null, { onUserPictureChange, changePassword })(ProfileView);


// WEBPACK FOOTER //
// ./src/views/ProfileView/ProfileView.jsx